import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  connect() {
    this.filters = [this.defaultTextFilter]
  }

  addFilters(...filters) {
    this.filters.push(...filters)
  }

  filter() {
    const term = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((el) => {
      const visible = this.filters.every((fn) =>
        fn.call(this, { el, term })
      )

      el.classList.toggle("hidden", !visible)
    })
  }

  defaultTextFilter({ el, term }) {
    if (!term) return true
    return el.innerText.toLowerCase().includes(term)
  }
}
